import { instance } from "../axios";

export const updateProductionStatus = async (
  productionId,
  status,
  centerId = undefined,
  shipmentId = undefined,
  comment = undefined
) => {
  const data = {
    status: status,
  };

  if (centerId !== undefined) {
    data.centerId = centerId;
  }

  if (shipmentId !== undefined) {
    data.shipmentId = shipmentId;
  }

  if (comment !== undefined) {
    data.comment = comment;
  }

  await instance.put(`/production/${productionId}`, data);
};

export const fetchProductionsByOrderId = async (orderId) => {
  const response = await instance.get(`/production/order/${orderId}`);
  return response.data;
};

export const destroyProductions = async (productionIds, destructionDate) => {
  const response = await instance.put("/production/destroy", {
    ids: productionIds,
    destructionDate,
  });

  return response.data;
};
